import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import './Pricing.css';

const Pricing = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const openWaitlist = () => {
    document.getElementById('waitlistModal').style.display = 'block';
    document.body.style.overflow = 'hidden';
  };

  const plans = [
    {
      title: '⭐ GusHome Renter',
      price: '$25',
      period: 'per month',
      features: [
        'Build equity in your rental automatically',
        'Earn rental income & appreciation',
        'Access your property dashboard',
        'Unlock exclusive rewards & discounts'
      ],
      cta: 'Join as Renter',
      featured: true
    },
    {
      title: 'GusHome Landlord',
      price: '$40',
      period: 'per month',
      features: [
        'Offer equity to attract tenants',
        'Boost retention with shared upside',
        'Powerful property management tools',
        'Market insights & performance analytics'
      ],
      cta: 'Upgrade as Landlord',
      featured: false
    },
    {
      title: 'GusHome Investor',
      price: '$10',
      period: 'per month',
      features: [
        'Fractional ownership in rentals',
        'Passive income & appreciation potential',
        'Access to the GusHome marketplace',
        'Premium investment insights'
      ],
      cta: 'Start Investing',
      featured: false
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <section id="pricing" className="pricing" ref={ref}>
      <div className="container">
        <motion.div 
          className="section-title"
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="migra-font">Simple, Transparent Pricing</h2>
          <p>Choose the plan that works for you. No hidden fees, no surprises.</p>
        </motion.div>
        
        <motion.div 
          className="pricing-grid"
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {plans.map((plan, index) => (
            <motion.div 
              key={index}
              className={`pricing-card ${plan.featured ? 'featured' : ''}`}
              variants={itemVariants}
              transition={{ duration: 0.6 }}
            >
              <h3>{plan.title}</h3>
              <div className="price">{plan.price}</div>
              <div className="period">{plan.period}</div>
              <ul className="pricing-features">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex}>{feature}</li>
                ))}
              </ul>
              <button className="cta-primary" onClick={openWaitlist}>
                {plan.cta}
              </button>
            </motion.div>
          ))}
        </motion.div>

        <motion.p
          className="pricing-cta-copy"
          initial={{ opacity: 0, y: 40 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.3 }}
        >
          Start building wealth through accessible real estate investment today. Choose the plan that fits your goals.
        </motion.p>
      </div>
    </section>
  );
};

export default Pricing;
